import script from "./PgmPayroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmPayroll.vue?vue&type=script&setup=true&lang=ts"

import "./PgmPayroll.vue?vue&type=style&index=0&id=a29bc17a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a29bc17a"]])

export default __exports__